import { ReportFetchParams } from '../redux/Report/Report.type';

export const mapReportParamsToCandidates = (
  reportParams: ReportFetchParams,
) => {
  const {
    from,
    to,
    experience_id,
    experiences,
    english_id,
    english,
    jobs,
    status_id,
    statuses,
    source_id,
    sources,
    hr_id,
    hrs,
    recruiter_id,
    recruiters,
    region_id,
    regions,
    department_id,
    departments,
    selectAll,
    hr_report,
  } = reportParams;

  const dateRange =
    from || to
      ? {
        start: from,
        end: to,
      }
      : undefined;
  const experience = experience_id ? [experience_id] : experiences ? [experiences] :[];
  const englishLevel = english_id ? [english_id] : english  ? [english] : [];
  const status = status_id ? [status_id] : statuses ? [statuses] : [];
  const source = source_id ? [source_id] : sources ? [sources] : [];
  const hr = hr_id ? [hr_id] : hrs ? [hrs] : [];
  const recruiter = recruiter_id ? [recruiter_id] : recruiters ? [recruiters] : [];
  const region = region_id ? [region_id] : regions ? [regions] : [];
  const department = department_id ? [department_id] : departments ? [departments] : [];

  return {
    dateRange,
    experience,
    englishLevel,
    jobs,
    status,
    source,
    hr,
    recruiter,
    region,
    department,
    selectAll,
    hr_report
  };
};
